import React from "react";

const MultipleQuestion = ({
    question,
    onChange
}) => {



    // * CONFIGURATION ARRAY
    const options = Array.isArray(question?.options)
        ? question.options
        : [];

    const allowMultiple = question?.allowMultiple === true;

    const displayType = question?.displayType || "checkbox";

    const handleMultipleChange = (value) => {

        onChange(
            "allowMultiple",
            value
        );

    };


    // * ADD OPTION
    const handleAddOption = () => {

        const newOption = {
            id: `${question?.id}-option-${Date.now()}-${Math.random()}`,
            text: ""
        };

        onChange(
            "options",
            [
                ...options,
                newOption
            ]
        );

    };

    const handleUpdateOption = (optionId, value) => {

        const updatedOptions = options.map((option) =>
            option?.id === optionId
                ? {
                    ...option,
                    text: value
                }
                : option
        );

        onChange(
            "options",
            updatedOptions
        );

    };


    // * DELETE

    const handleDeleteOption = (optionId) => {

        const updatedOptions = options.filter(
            (option) => option.id !== optionId
        );

        onChange(
            "options",
            updatedOptions
        );

    };

    return (
        <div className="survey-sampling-multiple-question">

            <div className="survey-sampling-multiple-header">

                <div className="survey-sampling-question-field">

                    <label className="survey-sampling-field-label">
                        Pregunta
                    </label>

                    <input
                        type="text"
                        className="survey-sampling-question-input"
                        value={question?.question || ""}
                        placeholder="Escriba la pregunta"
                        onChange={(event) =>
                            onChange(
                                "question",
                                event?.target?.value
                            )
                        }
                    />

                </div>

                <div className="survey-sampling-multiple-setting">

                    <span className="survey-sampling-field-label">
                        ¿Respuestas múltiples?
                    </span>

                    <div className="survey-sampling-segmented-control">

                        <button
                            type="button"
                            className={
                                allowMultiple
                                    ? "survey-sampling-segmented-button active"
                                    : "survey-sampling-segmented-button"
                            }
                            onClick={() =>
                                handleMultipleChange(true)
                            }
                        >
                            Sí
                        </button>

                        <button
                            type="button"
                            className={
                                !allowMultiple
                                    ? "survey-sampling-segmented-button active"
                                    : "survey-sampling-segmented-button"
                            }
                            onClick={() =>
                                handleMultipleChange(false)
                            }
                        >
                            No
                        </button>

                    </div>

                </div>

                <div className="survey-sampling-multiple-setting">

                    <span className="survey-sampling-field-label">
                        Presentación
                    </span>

                    <div className="survey-sampling-segmented-control">

                        <button
                            type="button"
                            className={
                                displayType === "checkbox"
                                    ? "survey-sampling-segmented-button active"
                                    : "survey-sampling-segmented-button"
                            }
                            onClick={() =>
                                onChange(
                                    "displayType",
                                    "checkbox"
                                )
                            }
                        >

                            <i className="fa fa-check-square-o"></i>
                            Casillas
                        </button>

                        <button
                            type="button"
                            className={
                                displayType === "button"
                                    ? "survey-sampling-segmented-button active"
                                    : "survey-sampling-segmented-button"
                            }
                            onClick={() =>
                                onChange(
                                    "displayType",
                                    "button"
                                )
                            }
                        >
                            <i className="fa fa-hand-pointer-o"></i>
                            Botones
                        </button>

                    </div>

                </div>

            </div>

            <div className="survey-sampling-multiple-information">

                <i className="fa fa-info-circle"></i>

                <span>
                    {allowMultiple
                        ? "El usuario podrá seleccionar una o varias respuestas."
                        : "El usuario solamente podrá seleccionar una respuesta."}
                </span>

            </div>

            <div className="survey-sampling-multiple-options">

                <div className="survey-sampling-multiple-options-title">
                    Opciones de respuesta
                </div>

                {options.map((option, index) => (

                    <div
                        key={option?.id}
                        className="survey-sampling-multiple-option-row"
                    >

                        <span className="survey-sampling-multiple-option-letter">
                            {String.fromCharCode(65 + index)}
                        </span>

                        <input
                            type="text"
                            className="survey-sampling-multiple-option-input"
                            value={option?.text ?? ""}
                            onChange={(event) =>
                                handleUpdateOption(
                                    option.id,
                                    event.target.value
                                )
                            }
                        />

                        <button
                            type="button"
                            className="survey-sampling-multiple-option-delete"
                            title={
                                options.length <= 2
                                    ? "Debe conservar al menos dos opciones"
                                    : "Eliminar opción"
                            }
                            onClick={() =>
                                handleDeleteOption(option?.id)
                            }
                        >
                            <i className="fa fa-trash-o"></i>
                        </button>

                    </div>

                ))}

                <button
                    type="button"
                    className="survey-sampling-add-option"
                    onClick={handleAddOption}
                >
                    <i className="fa fa-plus-circle"></i>

                    <span>
                        Agregar opción
                    </span>
                </button>

            </div>

        </div>
    );

};

export default MultipleQuestion;